
const requestApi = {
    wxapp:{
        index: "wxapp" // 授权
        // index: "wxdebug" // 测试
    },
    index:{
        main:"index.main",//首页信息
        shareconfig:"index.shareconfig", //获取后台分享设置
        share_url : "index.share_url", // 参数 
        get_location:'index.get_location',//获取地址
        get_search_info:"index.get_search_info",//获取搜索的信息
    },
    member:{
        comment: "member.comment", //获取用户评价
        get_member: "member.get_member", //获取用户信息
        get_member_balance: "member.get_member_balance", //获取用户余额
        get_coupons: "member.get_coupons", //获取用户优惠券
        get_capital: "member.get_capital", //获取用户优惠券
        get_down: "member.get_down", //获取用户下级列表
        apply_withdrawal: "member.apply_withdrawal", //提现申请
        get_browse: "member.get_browse", //用户浏览记录
        save_browse: "member.save_browse", //新增浏览记录
        maker_apply: "member.maker.apply", //
        get_commission: "member.get_commission", //获取佣金收入
        get_withdrawal_detail: "member.withdrawal_detail", //提现明细
        get_withdrawal: "member.get_withdrawal", // 提现记录列表 
        get_code: "member.verifycode", //获取验证码
        check_code: "member.check_code", //校验验证码
        tech_apply_submit: "member.tech_apply_submit", //技师申请提交
        create_commission_order: "member.create_commission_order", //购买199成为分销商订单
        recommend: "member.recommend_qrcode", //生成分销二维码
        recommend_store_qrcode: "member.recommend_store_qrcode", //生成门店推荐码
        create_recharge_order: "member.create_recharge_order" //充值余额
    },
    order:{
        place_order: "order.create.place_order", //下单页面
        balance_open:"order.create.balance_open",//开启余额抵扣
        select_store_list: "order.create.select_store_list", //选择门店列表
        select_tech_list: "order.create.select_tech_list", //选择技师列表
        select_tech: "order.create.select_tech", //选择技师
        select_coupon_list: "order.create.select_coupon_list", //选择优惠券列表
        select_coupon: "order.create.select_coupon", //选择优惠券
        select_time_detail: "order.create.select_time_detail", //选择时间页面
        select_time: "order.create.select_time", //选择服务时间和服务时长
        create_order: "order.create.create_order", //创建订单
        get_member_order: "order.member.get_member_order", //用户订单
        cancel_order: "order.member.cancel_order", //用户取消订单
        order_detail: "order.member.order_detail", //用户订单详情
        pay_order: "order.member.pay_order", //用户付款
        get_order_comments: "order.member.get_order_comments", //订单评论
        release_comments: "order.member.release_comments", //发布评论
        get_store_order: "order.store", //门店订单
        get_store_order_detail: "order.store.detail", //门店订单详情
        get_tech_order: "order.tech.get_tech_order", //技师订单
        qcore_verification: "order.tech.qcore_verification", //扫码核销
        get_tech_order_detail: "order.tech.detail", //订单详情
        tech_check_order: "order.tech.check_order", //技师确认订单
        begin_order: "order.tech.begin_order", //技师开始服务
        choose_tech_list:"order.member.choose_tech_list",//重新选择技师列表
        choose_tech:"order.member.choose_tech",//重新选择技师
        refund_order:"order.member.refund_order",//用户退款
    },
    service:{
        service_list: "service.index", //服务项目列表
        service_detail: "service.detail", //服务项目列表详情
    },
    store:{
        store_detail:"store.detail.main",//门店详情
        store_list:"store.list.main",//门店列表
        get_instore:"store.list.get_instore",//技师已入驻门店
        get_noinstore:"store.list.get_noinstore",//技师未入驻门店
        store_center:"store.store_center.main",//门店中心
        store_apply:"store.store_center.apply",//门店个人申请
        company_apply:"store.store_center.company_apply",//门店公司申请
        store_status:"store.store_center.store_status",//门店状态 营业或休息
        store_center_detail:"store.store_center.store_detail",//门店中心,门店详情
        store_detail_edit:"store.store_center.store_detail_edit",//门店中心 ，门店详情编辑
        store_select_tech:"store.tech_list.main",//门店中心  选择门店的技师
        store_select_service:"store.service.main",//门店中心  门店选择的服务项目
        store_service_edit:"store.service.service_select",//门店中心  门店编辑选取项目
        store_desc_edit:"store.store_center.store_desc_edit",//门店简介编辑
        store_order:"order.store.main",//门店中心  门店订单
        store_order_detail:"order.store.detail",//门店中心  门店订单详情
        store_income:"store.income.main",//门店中心收入
        store_withdrawal_detail:"store.income.store_withdrawal_detail",//门店中心 提现页面
        store_withdrawal:"store.income.store_withdrawal",//门店中心   收入提现
        store_achievement:"store.achievement.main",//门店中心  业绩查询
        change_store_avatar:"store.list.change_store_avatar"//上传门店头像
    },
    book:{
        book_list:"book.index", //预约
        get_store:"book.index.get_store",//获取门店
        get_tech:"book.index.get_tech",//获取技师
    },
    sysset:{
        sysset_shop:"index.sysset_shop" //获取系统配置
    },
    tech:{
        get_tech_list:"tech.get_tech_list",//获取技师列表
        get_tech: "tech.get_tech", // 获取技师信息
        get_tech_income: "tech.get_tech_income", // 技师收入
        apply: "tech.apply", // 申请技师
        join_store: "tech.join_store", // 技师加入或取消加入门店
        change_workstatus: "tech.change_workstatus", // 修改工作状态
        tech_detail: "tech.tech_detail", // 首页技师详情
        tech_withdrawal_detail: "tech.tech_withdrawal_detail", // 提现页面
        tech_withdrawal: "tech.tech_withdrawal", // 技师收入提现操作
        get_tech_withdrawal: "tech.get_tech_withdrawal",
        update_tech_info: "tech.update_tech_info", //修改技师信息
        get_tech_service: "tech.tech_service", //技师所勾选的服务
        update_tech_service: "tech.update_tech_service", //修改技师服务信息
        update_tech_work: "tech.update_tech_work", //修改技师从业信息
        tech_order_detail:"order.tech.detail",//技师订单详情
        tech_check_order:"order.tech.check_order",//技师确认接单
        tech_cancel_order:"order.tech.cancel_order",//技师取消接单
        tech_hexiao:"order.tech.tech_hexiao",//技师核销
        tech_begin_order:"order.tech.begin_order",//技师开始服务
        change_tech_avatar:"tech.change_tech_avatar",//更换技师头像
        get_agreement:"tech.agreement",//技师合作协议
    },
    wxpay:{
      AppoinTment : "order.pay.AppoinTment",
      rechange_commission : "order.pay.rechange_commission",
      rechange_balance: "order.pay.rechange_balance"
    }
}

export default {
    requestApi
}



// WEBPACK FOOTER //
// ./src/request/api.js